import { useDraggable } from '@dnd-kit/core';
import { Badge, Grid, Typography } from '@mui/material';
import React, { useState } from 'react'
import InfoIcon from '@mui/icons-material/Info';
import { TareaDialog } from '../proyectos/tareas/TareaDialog';
import { isColorDark } from '../../utils/utils';

export const TarjetaTarea = ({ id, tarea, setTarea, opcionesTareas, estados }) => {
	console.log('tarea', tarea);

	const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });
	const [backgroundCard, setBackgroundCArd] = useState(estados.find(estado => estado.id === tarea.id_estado).color);
	const [textColor, setTextColor] = useState(isColorDark(backgroundCard) ? '#FFFFFF' : '#000000');

	const [open, setOpen] = useState(false);
	const style = {
		transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
		background: 'var(--principal)',
		color: 'white',
		padding: '4px 8px',
		borderRadius: 4,
		marginBottom: 4,
		fontSize: 12,
		cursor: 'grab',
		position: 'relative', // por si hay stacking
		zIndex: transform ? 9999 : 'auto', // para que esté por encima al arrastrar
	};

	const handleEvent = (opcionId) => {
		switch (opcionId) {

			default:
				console.log("Lógica para una opción desconocida");
				// Lógica para una opción desconocida
				break;
		}
	}


	return (
		<div ref={setNodeRef} {...listeners} {...attributes} style={style}>
			<Grid container justifyContent='start' alignItems='center' gap={1} style={{ width: '100%' }}>

				<Grid item xs={1} onClick={() => setOpen(true)} className='pointer'>
					{/* <Badge badgeContent={tarea.comentarios.total_comentarios} color="primary"> */}
					{/* <InfoIcon sx={{ fontSize: 20, }}  /> */}
					{/* </Badge> */}
				</Grid>
				<Grid container xs={9} justifyContent={'space-between'}>
					<Typography fontSize={12}>{tarea.id}</Typography>
					<Typography fontSize={12}> {tarea.hora}</Typography>
				</Grid>
				<Grid container xs={12} marginTop={-1.5}>
					<Typography
						fontSize={12}
						sx={{
							display: '-webkit-box',
							overflow: 'hidden',
							WebkitBoxOrient: 'vertical',
							WebkitLineClamp: 1, // número de líneas visibles antes del corte
						}}
					>
						{tarea.asunto}
					</Typography>
				</Grid>

			</Grid>
			<Grid container xs={12} justifyContent={'space-between'}>
			
				 <TareaDialog open={open} setOpen={setOpen} tareaInfo={tarea} setTareaInfo={setTarea} opciones={opcionesTareas} handleEvent={handleEvent} backgroundCard={backgroundCard} textColor={textColor} /> 
			</Grid>

		</div>
	);
};


